import { type MouseEvent } from "react";
import { Link } from "react-router-dom";
import { t } from "../../i18n";

export type OrganizationConsoleNavGroup = {
  label: string;
  items: Array<{ key: string; label: string; href?: string }>;
};

export function OrganizationConsoleNav({
  basePath,
  activeTab,
  groups,
  dirty = false,
}: {
  basePath: string;
  activeTab: string;
  groups: OrganizationConsoleNavGroup[];
  dirty?: boolean;
}) {
  const confirmNavigation = (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      dirty &&
      !window.confirm(
        t("You have unsaved changes. Leave this section and discard them?"),
      )
    ) {
      event.preventDefault();
    }
  };

  return (
    <nav
      aria-label={t("Organization sections")}
      className="flex min-w-0 gap-1 overflow-x-auto rounded-xl border border-stone-200 bg-white p-1 dark:border-white/10 dark:bg-white/3"
    >
      {groups.map((group) => (
        <div
          key={group.label}
          className="flex shrink-0 items-center gap-1 border-r border-stone-200 pr-1 last:border-r-0 last:pr-0 dark:border-white/10"
        >
          <span className="px-2 text-[10px] font-bold tracking-wider text-stone-400 uppercase">
            {t(group.label)}
          </span>
          {group.items.map((item) => (
            <Link
              key={item.key}
              className={activeTab === item.key ? "button-primary" : "button"}
              to={item.href ?? `${basePath}/${item.key}`}
              onClick={confirmNavigation}
            >
              {t(item.label)}
            </Link>
          ))}
        </div>
      ))}
    </nav>
  );
}
